<template>
    <div>

        <div class="is-clipped lb-embed-height background-login">
            <slot ></slot>
        </div>
        
    </div>
</template>

<script>
import { projectBackground } from '@/lib/helpers';
import _ from 'underscore';
export default {
    components: {
    },
    data() {
        return {
            showResumeModal: false,
            showShareModal: false,
            embed: this.$route.meta.embed,
            hideLogin: this.$route.meta.hideLogin,
        };
    },
    computed: {
        projectBackgroundStyle() {
            const bg = this.$store.getters.projectBackground;
            const bgImage = this.$store.getters.projectBackgroundImage;
            return projectBackground(_.isEmpty(bgImage) ? bg : bgImage);
        },
    },
    methods: {
        showInfo(e){
            // console.log("in show info")
            this.showResumeModal=true
        }
    },
    beforeCreate() {
        document.body.classList.remove('has-navbar-fixed-top');
    },
    destroyed() {
        document.body.classList.add('has-navbar-fixed-top');
    },
    
};
</script>
<style scoped>
.background-login {
    background-image: url('/img/login_background.png');
    height: 100%;
    width: 100%;
    position: absolute;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>


